module.exports = __webpack_public_path__ + "img/me_set_icon.6a9698a1.svg";